import { normalizeOrgEnabledServices } from '../../enterprise/admin-shared/orgEnabledServices';

/** Portal enabled_services → production salon hub tiles (enterprise only). */
export const ENTERPRISE_HUB_OPTION_SERVICE = {
  salon: 'skin_analysis',
  'hair-analyze': 'hair_analysis',
  'makeup-studio': 'makeup',
  'hair-coloring': 'hair_coloring',
  'hair-styling-pro': 'hair_style',
};

const SALON_ORG_SERVICES_KEY = 'enterprise_salon_org_enabled_services';

export function persistSalonHubOrgServices(services) {
  const list = normalizeOrgEnabledServices(services);
  try {
    const json = JSON.stringify(list);
    sessionStorage.setItem(SALON_ORG_SERVICES_KEY, json);
    localStorage.setItem(SALON_ORG_SERVICES_KEY, json);
  } catch {
    /* ignore */
  }
}

export function readSalonHubOrgServices() {
  try {
    const raw =
      sessionStorage.getItem(SALON_ORG_SERVICES_KEY) ||
      localStorage.getItem(SALON_ORG_SERVICES_KEY);
    if (!raw) return [];
    return normalizeOrgEnabledServices(JSON.parse(raw));
  } catch {
    return [];
  }
}

/** Enterprise production hub: gate tiles by nyafaz-portal org services. Test hub unchanged. */
export function isEnterpriseProductionHubOptionVisible(option, orgServices, testMode) {
  if (testMode) {
    return Boolean(option.testOnly) === testMode;
  }
  if (option.testOnly) return false;
  const svc = ENTERPRISE_HUB_OPTION_SERVICE[option.id];
  if (!svc) return Boolean(option.always);
  const list = normalizeOrgEnabledServices(orgServices);
  if (!list.length) return false;
  return list.includes(svc);
}
